
import Vue, { PropType } from 'vue'

interface LogEntry {
  id: number;
  topic: string;
  subtopic: string | null;
  // eslint-disable-next-line camelcase
  log_level: string;
  // eslint-disable-next-line camelcase
  created_at: string;
  endpoint: string | null;
  // eslint-disable-next-line camelcase
  request_method: string | null;
  // eslint-disable-next-line camelcase
  status_code: number | null;
  // eslint-disable-next-line camelcase
  response_time_ms: number | null;
  log: string;
  payload: Record<string, unknown> | null;
  // eslint-disable-next-line camelcase
  user_id: number | null;
  // eslint-disable-next-line camelcase
  organization_id: number | null;
  // eslint-disable-next-line camelcase
  role_id: number | null;
  // eslint-disable-next-line camelcase
  ip_address: string | null;
  // eslint-disable-next-line camelcase
  user_agent: string | null;
  // eslint-disable-next-line camelcase
  correlation_id: string | null;
  // eslint-disable-next-line camelcase
  client_id: string | null;
}

export default Vue.extend({
  name: 'LogDetailsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    log: {
      type: Object as PropType<LogEntry | null>,
      default: null
    }
  },
  methods: {
    formatDate (dateStr: string): string {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
    },
    getLogLevelColor (level: string): string {
      const colors: { [key: string]: string } = {
        DEBUG: 'grey',
        INFO: 'blue',
        WARNING: 'orange',
        ERROR: 'red',
        CRITICAL: 'deep-purple'
      }
      return colors[level] || 'grey'
    },
    getStatusCodeColor (code: number): string {
      if (code >= 200 && code < 300) return 'success'
      if (code >= 300 && code < 400) return 'info'
      if (code >= 400 && code < 500) return 'warning'
      if (code >= 500) return 'error'
      return 'grey'
    }
  }
})
